import store from '../store/store';
import AppearanceOptionState from '../store/schema/AppearanceOptionState';
import { mutatorAction } from 'satcheljs';

/**
 * Called when we change working hours start time
 * @timeInMinutes: new value for start time in minutes
 */
export default mutatorAction('setWorkingHoursStartTimeOption', function(timeInMinutes: number) {
    let optionState: AppearanceOptionState = store();
    optionState.workingHoursStartTime = timeInMinutes;
});
